import { render } from "./com_inscripciones.vue?vue&type=template&id=a6f7b216&scoped=true"
import script from "./com_inscripciones.vue?vue&type=script&lang=js"
export * from "./com_inscripciones.vue?vue&type=script&lang=js"

import "./com_inscripciones.vue?vue&type=style&index=0&id=a6f7b216&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f7b216"]])

export default __exports__